import 'core-js/fn/array/from'
import React from 'react'

import IndexListItem from './IndexListItem'

import { ListItem, PageList } from './Pagination.styles'

/*
  If total pages are less than 11, just render them out
  Else
    If current page is less than 5, render first 5 ... n
    If current page is among the last 5, render 1 ... (n-5...n)
    Else
      Render 1 ... (i - 3 ... i ... i+2) n
*/

export default ({ totalPages, criterion, currentIndex, setIndex }) => {
  const { total } = criterion

  if (!total) {
    return <li>No data</li>
  }
  let itemsArr

  if (totalPages <= 10) {
    itemsArr = Array.from(Array(totalPages), (_, idx) => ({
      isActive: currentIndex === idx,
      key: `inner${idx}`,
      onClick: () => setIndex(idx),
      text: idx + 1
    }))
  } else if (currentIndex < 5) {
      itemsArr = [
        ...Array.from(Array(5), (_, idx) => ({
          isActive: currentIndex === idx,
          key: `inner${idx}`,
          onClick: () => setIndex(idx),
          text: idx + 1
        })),
        {
          type: 'ellip',
          key: 'ellip-1'
        },
        {
          isActive: currentIndex === totalPages - 1,
          key: 'skip-1',
          onClick: () => setIndex(totalPages - 1),
          text: totalPages
        }
      ]
    } else if (currentIndex > totalPages - 5) {
      itemsArr = [
        {
          isActive: currentIndex === 0,
          key: 'skip-1',
          onClick: () => setIndex(0),
          text: 1
        },
        {
          type: 'ellip',
          key: 'ellip-1'
        },
        ...Array.from(Array(5), (_, idx) => ({
          isActive: currentIndex === totalPages - idx - 1,
          key: `totalPages-idx-${totalPages - idx - 1}`,
          onClick: () => setIndex(totalPages - idx - 1),
          text: totalPages - idx
        })).reverse()
      ]
    } else {
      // in between homes
      const lowerBound = currentIndex - 3

      itemsArr = [
        {
          isActive: currentIndex === 1,
          key: 'skip-1',
          onClick: () => setIndex(0),
          text: 1
        },
        {
          type: 'ellip',
          key: 'ellip-1'
        },
        ...Array.from(Array(5), (_, idx) => ({
          isActive: currentIndex === lowerBound + idx,
          key: `lowerBound+idx-${lowerBound + idx}`,
          onClick: () => setIndex(lowerBound + idx),
          text: lowerBound + idx + 1
        })),
        {
          type: 'ellip',
          key: 'ellip-2'
        },
        {
          isActive: currentIndex === totalPages - 1,
          key: 'skip-2',
          onClick: () => setIndex(totalPages - 1),
          text: totalPages
        }
      ]
    }

  return (
    <PageList>
      <ol>
        {itemsArr.map(item => {
          if (item.type === 'ellip') {
            return <ListItem key={item.key}>...</ListItem>
          } else {
            return <IndexListItem {...item} />
          }
        })}
      </ol>
    </PageList>
  )
}
